/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './styles.css';
import logo from '@assets/images/logo.png';

import { useDispatch, useSelector } from 'react-redux';
import { ComboBox, Button } from '@components';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { searchValues } from '@utils';
import { mdiMagnify } from '@mdi/js';
import { alteraPlano } from '../../../store/user/thunks';
import { getPerfilInvestimento } from '../../../store/plan/thunks';
import {
  useUserData,
  useDadosPessoais,
  useIsLogged,
} from '../../../store/hooks';

import { Relogio } from '../Relogio';
import { useAuth } from '../../../pages/Shell';
import { HOME } from '../../utils/paths';
import Icons from '../Icon';

const CustomizedAutocomplete = styled((props) => (
  <Autocomplete {...props} inputMode="search" />
))`
  .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color);
    border-radius: 25px;
  }
`;

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useAuth();
  const userData = useUserData();
  const dadosPessoais = useDadosPessoais();
  const isLogged = useIsLogged();
  const custom = useSelector((state) => state.configs.tema);
  const telasDisponiveis = useSelector(
    (state) => state.configs.telasDisponiveis.data
  );
  const perfilInvestimento = useSelector(
    (state) => state.plan.perfilInvestimento
  );
  const [modoSimulacao, setModoSimulacao] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('0');
  const [search, setSearch] = useState('');

  const filteredOptions = searchValues.filter((option) => {
    const alwaysShow = option.id.length === 0;
    const screenEnabled = option.id.some((id) => telasDisponiveis?.[id]);

    return alwaysShow || screenEnabled;
  });

  const alteraValoresStore = useCallback(
    (plan) => {
      dispatch(alteraPlano(plan));
    },
    [dispatch]
  );

  const logout = () => {
    auth.signout();
  };

  useEffect(() => {
    const planos = dadosPessoais.planoPrevidencia || [];

    if (!planos.length) {
      return;
    }

    const planoAtualId =
      userData.plano || planos[0]?.id?.toString() || planos[0]?.id;

    const currentPlan = planos.find(
      (plan) => plan.id.toString() === planoAtualId.toString()
    );

    if (currentPlan) {
      setSelectedPlan(currentPlan.id.toString());
    }
  }, [userData.plano, dadosPessoais.planoPrevidencia]);

  useEffect(() => {
    const idLocalStorage = localStorage.getItem('Id');

    if (isLogged && idLocalStorage && userData.matricula) {
      setModoSimulacao(Number(idLocalStorage) !== Number(userData.matricula));
      return;
    }

    setModoSimulacao(false);
  }, [isLogged, userData.matricula]);

  useEffect(() => {
    if (
      isLogged &&
      userData.matricula &&
      userData.plano &&
      !perfilInvestimento.loading &&
      !perfilInvestimento.data?.Label
    ) {
      dispatch(getPerfilInvestimento());
    }
  }, [
    dispatch,
    isLogged,
    userData.matricula,
    userData.plano,
    perfilInvestimento.loading,
    perfilInvestimento.data,
  ]);

  return (
    <>
      {modoSimulacao && (
        <div className="topHeader">
          <h4>FORLUZ : FORLUZ : FORLUZ : FORLUZ : FORLUZ : FORLUZ</h4>
        </div>
      )}
      <div className="header mb-32">
        <div data-tour="step-0">
          <Link to={HOME}>
            <img className="logo" src={logo} alt="Forluz logo" />
          </Link>
          <div className="relogio">
            <div className="d-none d-lg-flex align-items-center">
              <Relogio />
            </div>
          </div>
        </div>
        <div
          className="d-none d-lg-flex align-items-center gap-3"
          data-tour="step-1"
        >
          {Array.isArray(dadosPessoais.planoPrevidencia) &&
            dadosPessoais.planoPrevidencia.length > 0 && (
              <ComboBox
                color={custom.nomeCorPrincipal}
                options={dadosPessoais.planoPrevidencia.map((x) => {
                  return { value: x.id.toString(), label: x.name };
                })}
                value={selectedPlan}
                onChange={(value) => {
                  alteraValoresStore(value);
                  setSelectedPlan(value);
                }}
              />
            )}
          <CustomizedAutocomplete
            size="small"
            freeSolo
            options={filteredOptions.map((option) => option.title)}
            onChange={(e, value) => {
              const route = filteredOptions.find(
                (op) => op.title === value
              )?.path;

              if (route) {
                navigate(route);
              }
            }}
            onInputChange={(e, value) => setSearch(value)}
            className="w-250"
            renderInput={(params) => (
              <TextField
                {...params}
                label="O que você procura?"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icons path={mdiMagnify} color="#727272" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
            value={search}
          />
        </div>
        <div className="d-none d-lg-flex align-items-center">
          <Button
            className="force-orange-color"
            onClick={() => {
              navigate(HOME);
            }}
          >
            {`${userData.matricula} - ${dadosPessoais.nome}`}
          </Button>
        </div>
        <div className="d-flex d-lg-none">
          {Array.isArray(dadosPessoais.planoPrevidencia) &&
            dadosPessoais.planoPrevidencia.length > 0 && (
              <ComboBox
                color={custom.nomeCorPrincipal}
                options={dadosPessoais.planoPrevidencia.map((x) => {
                  return { value: x.id.toString(), label: x.name };
                })}
                value={selectedPlan}
                onChange={(value) => {
                  alteraValoresStore(value);
                  setSelectedPlan(value);
                }}
              />
            )}
          <Button
            className="only-icon ms-3"
            transparent
            color="orange"
            icon="search"
          />
          <Button
            className="only-icon ms-3"
            transparent
            color="muted"
            icon="clear"
            onClick={() => logout()}
          />
        </div>
      </div>
    </>
  );
};
